import PropTypes from 'prop-types';

import { simpleRichTextType } from 'humanity/components/simpleRichText/simpleRichText.types';

export const lcTextCardProps = {
  title: PropTypes.string,
  content: simpleRichTextType,
};

export const lcTextCardType = PropTypes.shape({ ...lcTextCardProps });
